// Maps RVR1960 JSON book names to books.ts book IDs
export const RVR1960_BOOK_MAP: Record<string, string> = {
  'Génesis': 'génesis',
  'Éxodo': 'éxodo',
  'Levítico': 'levítico',
  'Números': 'números',
  'Deuteronomio': 'deuteronomio',
  'Josué': 'josué',
  'Jueces': 'jueces',
  'Rut': 'rut',
  '1 Samuel': '1samuel',
  '2 Samuel': '2samuel',
  '1 Reyes': '1reyes',
  '2 Reyes': '2reyes',
  '1 Crónicas': '1crónicas',
  '2 Crónicas': '2crónicas',
  'Esdras': 'esdras',
  'Nehemías': 'nehemías',
  'Ester': 'ester',
  'Job': 'job',
  'Salmos': 'salmos',
  'Proverbios': 'proverbios',
  'Eclesiastés': 'eclesiastés',
  'Cantares': 'cantardeloscantares',
  'Isaías': 'isaías',
  'Jeremías': 'jeremías',
  'Lamentaciones': 'lamentaciones',
  'Ezequiel': 'ezequiel',
  'Daniel': 'daniel',
  'Oseas': 'oseas',
  'Joel': 'joel',
  'Amós': 'amós',
  'Abdías': 'abdías',
  'Jonás': 'jonás',
  'Miqueas': 'miqueas',
  'Nahúm': 'nahúm',
  'Habacuc': 'habacuc',
  'Sofonías': 'sofonías',
  'Hageo': 'ageo',
  'Zacarías': 'zacarías',
  'Malaquías': 'malaquías',
  'S. Mateo': 'mateo',
  'S. Marcos': 'marcos',
  'S. Lucas': 'lucas',
  'S.Juan': 'juan',
  'Hechos': 'hechos',
  'Romanos': 'romanos',
  '1 Corintios': '1corintios',
  '2 Corintios': '2corintios',
  'Gálatas': 'gálatas',
  'Efesios': 'efesios',
  'Filipenses': 'filipenses',
  'Colosenses': 'colosenses',
  '1 Tesalonicenses': '1tesalonicenses',
  '2 Tesalonicenses': '2tesalonicenses',
  '1 Timoteo': '1timoteo',
  '2 Timoteo': '2timoteo',
  'Tito': 'tito',
  'Filemón': 'filemón',
  'Hebreos': 'hebreos',
  'Santiago': 'santiago',
  '1 Pedro': '1pedro',
  '2 Pedro': '2pedro',
  '1 Juan': '1juan',
  '2 Juan': '2juan',
  '3 Juan': '3juan',
  'Judas': 'judas',
  'Apocalipsis': 'apocalipsis',
};

// Reverse map: books.ts book ID -> RVR1960 JSON book name
export const RVR1960_BOOK_REVERSE: Record<string, string> = {};
for (const [jsonName, bookId] of Object.entries(RVR1960_BOOK_MAP)) {
  RVR1960_BOOK_REVERSE[bookId] = jsonName;
}
